module.exports = __webpack_public_path__ + "img/DocumentStorage.3fd76045.svg";